import statusStyles from './statusStyles.css';

/*this component outputs the status selector as radio buttons
Props:
 
*/
export function StatusRadioButtons (props) {

	let buttons = [],
		choices = {
			'Active':'Active', 
			'Candidate':'Candidate', 
			'Retired':'Retired',
		};
	//if there are no choices then stop and return nothing
	if( props.concept == 'question') {
		choices = {
		'Active':'Active', 
		'Answered':'Answered', 
		'Candidate':'Candidate', 
		'Retired':'Retired',
		};
	} 

	for (const [index, choice] of Object.entries(choices)) {
		let check = '';
		if( props.defaultChecked == choice) {
			check = "defaultChecked";
		} 

		buttons.push(
		<div className={statusStyles.statusLabelInputHolder} key={choice}>
			<input 
				type="radio" 
				name={props.name}  
				className={statusStyles.statusInputRadio}
				value={choice}
				defaultChecked={check}
				id={'radio-' +choice+ '-' +props.id} 
				onChange={props.onChange}
				{...props.attributes}
			/>
			<label for={'radio-' +choice+ '-' +props.id} className={statusStyles.statusLabelRadio}>
				{choice}
			</label>
		</div>)
	}
	return (buttons);
}